import { NavLink } from "react-router-dom";

const menuItems = [
  { path: "/admin/dashboard", icon: "bi-speedometer2", label: "Dashboard" },
  { path: "/admin/settings", icon: "bi-gear", label: "Site Settings" },
  { path: "/admin/sliders", icon: "bi-images", label: "Homepage Sliders" },
  {
    path: "/admin/content",
    icon: "bi-file-text",
    label: "Vision/Mission/About",
  },
  { path: "/admin/facilities", icon: "bi-building", label: "Facilities" },
  { path: "/admin/trust-team", icon: "bi-people", label: "Trust Team" },
  { path: "/admin/school-team", icon: "bi-person-badge", label: "School Team" },
  { path: "/admin/gallery", icon: "bi-collection", label: "Gallery" },
  { path: "/admin/documents", icon: "bi-file-earmark-pdf", label: "Documents" },
  { path: "/admin/notifications", icon: "bi-bell", label: "Notifications" },
  { path: "/admin/contact", icon: "bi-telephone", label: "Contact Info" },
  { path: "/admin/enquiries", icon: "bi-envelope", label: "Enquiries" },
  {
    path: "/admin/pages",
    icon: "bi-file-earmark-richtext",
    label: "Custom Pages",
  },
  { path: "/admin/menu", icon: "bi-list-nested", label: "Menu Builder" },
];

function Sidebar({ isOpen, onClose }) {
  return (
    <>
      {/* Overlay for mobile — clicking outside the sidebar closes it */}
      {isOpen && (
        <div
          className="d-lg-none position-fixed top-0 start-0 w-100 h-100 bg-dark opacity-50"
          style={{ zIndex: 1040 }}
          onClick={onClose}
        ></div>
      )}

      <aside
        className={`bg-dark text-white position-fixed top-0 start-0 h-100 ${isOpen ? "" : "d-none d-lg-block"}`}
        style={{ width: "260px", zIndex: 1045, overflowY: "auto" }}
      >
        <div className="d-flex align-items-center gap-2 p-3 border-bottom border-secondary">
          <i className="bi bi-mortarboard-fill text-primary fs-4"></i>
          <span className="fw-semibold">School Admin</span>
        </div>

        <nav className="p-2">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) =>
                `d-flex align-items-center gap-2 px-3 py-2 rounded text-decoration-none mb-1 ${
                  isActive ? "bg-primary text-white" : "text-white-50"
                }`
              }
              style={{ transition: "background 0.15s" }}
            >
              <i className={`bi ${item.icon}`}></i>
              <span className="small">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
